import { Suspense } from 'react';
import { Outlet, generatePath, useMatch } from 'react-router-dom';
import styled from 'styled-components';

import { Navigate, catchAll, useTypedParams } from '@sorare/routing';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  MLB_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION,
  MLB_PLAY_LOBBY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useLastVisitedEventType } from '@sorare/core/src/hooks/useLastVisitedEventType';
import { useNewLobbyFF } from '@sorare/core/src/hooks/useNewLobbyFF';

import { ImportLineup } from '@sorare/gameplay/src/components/importLineup/ImportLineup';

import { LayoutParams } from './__generated__/routeParams';

const Relative = styled.div`
  position: relative;
  isolation: isolate;
`;
const PlayProLayout = () => {
  const useNewLobby = useNewLobbyFF();
  const { eventType } = useTypedParams<LayoutParams>();
  const { lastVisitedEventType, setLastVisitedEventType } =
    useLastVisitedEventType();

  // Competitions pages where still on the old routes, so we need this little hack to let them through without exposing the new lobby
  const allRoutes = useMatch(
    catchAll(MLB_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION)
  );

  if (lastVisitedEventType !== eventType) {
    setLastVisitedEventType(eventType);
  }

  if (!useNewLobby && !allRoutes) {
    return <Navigate to={generatePath(MLB_PLAY_LOBBY)} />;
  }

  return (
    <Relative>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
        <ImportLineup />
      </Suspense>
    </Relative>
  );
};

export default PlayProLayout;
